import { render, staticRenderFns } from "./ApartsMap.vue?vue&type=template&id=1890678a"
import script from "./ApartsMap.vue?vue&type=script&lang=js"
export * from "./ApartsMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports